import request, { Response } from "@/utils/request";
import { ImgCode, LoginForm, LoginRes, Page } from "@/types";
import { LoginLog } from "@/types/login/index";

export const getImgCode = () => {
    return request<ImgCode>("/admin/captcha");
};

export const login = (loginForm: LoginForm) => {
    return request.post<LoginRes>("/admin/login", loginForm);
};

export const loginOut = () => {
    return request.post("/loginOut");
};

export const getLoginLog = (data: any) => {
    return request.post<Page<LoginLog>>("/admin/loginLog", data);
};
